import { render } from "./header-learning-map-student.vue?vue&type=template&id=18d48969&ts=true"
import script from "./header-learning-map-student.vue?vue&type=script&lang=ts"
export * from "./header-learning-map-student.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__